<div echarts [options]="barChartOption" *ngIf="type==1" class="chartContainer"></div>
<div echarts [options]="barChartOption2" *ngIf="type==2" style="height: 320px;"></div>